module["exports"] = [
  "市",
  "区",
  "町",
  "村"
];
